const ADMIN_CHIM_DIRS = ["ryan"];

export const canEditSleeve = (userDir, sleeveChimDir) => {
  if (!userDir) return false;
  if (userDir === sleeveChimDir) return true;
  return ADMIN_CHIM_DIRS.includes(userDir);
};

export default canEditSleeve;
